document.addEventListener('DOMContentLoaded', function() {
  // Buscar todas las secciones custom-liquid que contienen accordion-content
  const accordionContainers = document.querySelectorAll('[id*="accordion-content"]');

  if (!accordionContainers.length) {
    return;
  }

  accordionContainers.forEach(function(content) {
    if (!content) return;

    const textContent = content.textContent.replace(/\s+/g, '').trim();
    if (!textContent) return;

    content.classList.add('collection-description-content');

    // Buscar la sección padre más cercana
    const section = content.closest('.shopify-section');
    if (!section) return;

    // Remover botón existente
    const existingButton = section.nextElementSibling;
    if (existingButton && existingButton.classList.contains('collection-description-toggle')) {
      existingButton.remove();
    }

    content.classList.remove('expanded');
    content.classList.add('collapsed');

    const hasOverflow = content.scrollHeight > content.clientHeight + 1;
    if (!hasOverflow) {
      content.classList.remove('collapsed');
      return;
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'collection-description-toggle';
    button.textContent = 'Leer más';

    section.insertAdjacentElement('afterend', button);

    button.addEventListener('click', function(e) {
      e.preventDefault();
      const isCollapsed = content.classList.contains('collapsed');

      if (isCollapsed) {
        content.classList.remove('collapsed');
        content.classList.add('expanded');
        button.textContent = 'Leer menos';
      } else {
        content.classList.remove('expanded');
        content.classList.add('collapsed');
        button.textContent = 'Leer más';
      }
    });

    // Para enlaces internos en el acordeon, expandir primero y luego hacer scroll al ancla.
    content.addEventListener('click', function(e) {
      const link = e.target.closest('a[href]');
      if (!link) return;

      const rawHref = link.getAttribute('href');
      if (!rawHref || rawHref.startsWith('javascript:')) return;

      let url;
      try {
        url = new URL(rawHref, window.location.href);
      } catch (error) {
        return;
      }

      const normalizePath = function(pathname) {
        if (!pathname) return '/';
        return pathname.replace(/\/+$/, '') || '/';
      };

      const isSamePage =
        url.origin === window.location.origin &&
        normalizePath(url.pathname) === normalizePath(window.location.pathname) &&
        url.search === window.location.search;

      // Solo interceptamos anclas de la pagina actual.
      if (!isSamePage || !url.hash) return;

      const targetId = decodeURIComponent(url.hash.slice(1));
      if (!targetId) return;

      e.preventDefault();

      const targetElement = document.getElementById(targetId);
      if (!targetElement) {
        window.location.hash = url.hash;
        return;
      }

      const isCollapsed = content.classList.contains('collapsed');
      if (isCollapsed) {
        button.click();
      }

      setTimeout(function() {
        // Usamos offsetTop acumulado para obtener la posición absoluta en el documento
        // independientemente del estado del scroll en el momento del cálculo.
        let absoluteTop = 0;
        let el = targetElement;
        while (el && el !== document.body) {
          absoluteTop += el.offsetTop;
          el = el.offsetParent;
        }
        const headerEnd = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-end')) || 0;
        window.scrollTo({ top: absoluteTop - headerEnd - 20, behavior: 'smooth' });
        history.pushState(null, '', '#' + targetId);
      }, isCollapsed ? 350 : 50);
    });
  });
});
